import React, { Component } from 'react'
import Settings from '../settings'
// import ReactGA from 'react-ga'

// This component:
// 1. Sets up the basic page structure - kind of like your index.html used to.
// 2. Adds the layout switcher from ACF (flexible content modules)
// 3. Adds all the background elements

// Import Page Components
import Navigation from './Navigation'
import Announcement from './Announcement'
import Header from './HeaderPage'
import Footer from './Footer'
import Sections from './Sections'

// Import Animation timline controls
import ScrollMagic from 'scrollmagic'


// Main component - will be rendered to #root in public/index.html
class App extends Component {

  constructor() {
    super()

    // Basic empty structure for app data.
    this.state = {
      navigation: {},
      announcement: {
        show: false
      },
      header: {},
      footer: {},
      data: {
        acf: {
          layout: []
        },
        title: { rendered: ''}
      },
      events: {}
    }
  }

  getPage = (slug) => {
    let dataURL = `${ Settings.api }/pages/?slug=${ slug }`
    fetch(dataURL)
      .then(res => res.json())
      .then(res => {
        this.setState({
          data: res[0]
        })
        // console.log(this.state);
      })
      .catch(res => {
        console.log('404 on /'+slug);
        if (slug!=='home') {
          console.log("loading /home instead");
          this.getPage('home')
        } else {
          console.log("couldn't load /home");
        }
      })
  }

  getOptions = (slug) => {
    fetch(`${ Settings.acf }/options/${ slug }`)
      .then(res => res.json())
      .then(res => {
        this.setState({
          navigation: res.acf,
          footer: res.acf
        })
        // console.log('options', res);
      })
      .catch(res => {
        console.log('404 on /'+slug, res);
      })
  }


  componentWillMount() {
    // Setup controller for scroll animations
    this.controller = new ScrollMagic.Controller();

    // Setup Google Analytics
    // ReactGA.initialize('UA-30021343-3');
    // ReactGA.pageview(window.location.pathname);

    // Fetch app data from WP-API
    this.getPage(this.props.match.params.slug)
    this.getOptions('header-footer')
    // this.getEvents()
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    // console.log(this.state.data);
    return (
      <div>
        <div className="App" id="top">
          {/* Page Components
            - pass controller to anything that uses ScrollMagic
            - pass data to anything with text - will automatically handle language
          */}
          <Navigation data={this.state.navigation} />
          <Announcement data={this.state.announcement} />
          <Header data={this.state.header} controller={this.controller} page={this.state.data} />
          <Sections data={this.state.data} />
          <Footer data={this.state.footer} controller={this.controller} />
          <div className="blurred-edge-top"></div>
          <div className="blurred-edge"></div>
        </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/AppPage.js